An address of a human-accessible web page.
